import { useCurrentWorkspace } from 'hooks/useCurrentWorkspace'
import { useMemo } from 'react'
import dayjs from 'dayjs'

export const useIsGenerationPaused = () => {
  const workspace = useCurrentWorkspace()

  return useMemo(() => {
    if (!workspace) return false
    return (
      workspace.pause_autopilot_generate_at ||
      (workspace.resume_autopilot_generate_at && dayjs(workspace.resume_autopilot_generate_at).isAfter(dayjs()))
    )
  }, [workspace])
}
